// extracted by mini-css-extract-plugin
module.exports = {"playButton":"playbutton_playButton__6gBQ4","btn":"playbutton_btn__23UXO"};